import { render, staticRenderFns } from "./addJC.vue?vue&type=template&id=2b6a7010&scoped=true&"
import script from "./addJC.vue?vue&type=script&lang=js&"
export * from "./addJC.vue?vue&type=script&lang=js&"
import style0 from "./addJC.vue?vue&type=style&index=0&id=2b6a7010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a7010",
  null
  
)

export default component.exports